<template>
	<button type="button" class="deliverable" @click="$emit('open-deliverable')">
		<strong>{{ deliverable.name }}</strong>
		<span class="deliverable-meta">
			<span>
				<portal-icon name="message-circle-question" :size="14"></portal-icon>
				{{ commentCount }} {{ $t('projects.comments') }}
			</span>
			<span>
				<portal-icon name="folder-open" :size="14"></portal-icon>
				{{ fileCount }} {{ $t('projects.attachments') }}
			</span>
			<span v-if="deliverable.dueDate">
				<portal-icon name="calendar-days" :size="14"></portal-icon>
				{{ $t('projects.due') }} {{ DateTime.fromISO(deliverable.dueDate).toFormat('DD') }}
			</span>
		</span>
		<span class="deliverable-footer">
			<portal-status-pill
				v-if="deliverable.approvalRequestedAt"
				background="var(--v-blue_10-base)"
				color="var(--portal-text)"
			>
				{{ $t('projects.requested') }} {{ DateTime.fromISO(deliverable.approvalRequestedAt).toFormat('DD') }}
			</portal-status-pill>
			<portal-status-pill
				v-if="lastApproval && !deliverable.approvalRequired"
				background="var(--v-success_10-base)"
				color="var(--v-success-base)"
			>
				{{ $t('projects.submitted') }} {{ DateTime.fromISO(lastApproval.approvedAt).toFormat('DD') }}
			</portal-status-pill>
			<portal-icon name="chevron-right" :size="16"></portal-icon>
		</span>
	</button>
</template>

<script>
import {DateTime} from 'luxon';

export default {
  name: 'DeliverableCard',

  props: ['deliverable','statusList'],

  components: {},

  data: function() {
    return {
      DateTime:DateTime,
    };
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {},

  computed: {
		commentCount() {
			return this.deliverable.comments ? this.deliverable.comments.length : 0;
		},

		fileCount() {
			return this.deliverable.files ? this.deliverable.files.length : 0;
		},

    currentStatus: function(){
      return this.statusList.find(s => s.id === this.deliverable.statusId);
    },

    lastApproval: function(){
      if(this.deliverable.approvals && this.deliverable.approvals.length){
        return this.deliverable.approvals[this.deliverable.approvals.length-1];
      } else{
        return null;
      }
    }
  },

};
</script>

<style scoped lang="scss">
  .deliverable {
    width: 100%;
    min-width: 0;
    display: grid;
    gap: 9px;
    text-align: left;
    border: 1px solid var(--portal-border);
    border-radius: var(--brand-surface-radius, 12px);
    box-sizing: border-box;
    background: var(--portal-surface);
    color: var(--portal-text);
    padding: 12px;
    cursor: pointer;
    transition: border-color 140ms ease, background-color 140ms ease;
  }

  .deliverable:hover {
    border-color: color-mix(in srgb, var(--v-primary-base) 24%, var(--portal-border));
    background: var(--v-gray_10-base);
  }

  .deliverable:focus-visible {
    outline: 2px solid var(--v-primary-base);
    outline-offset: 2px;
  }

  .deliverable > strong {
    font-size: 14px;
    font-weight: 650;
  }

  .deliverable-meta {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    color: var(--portal-muted);
    font-size: 12px;
  }

  .deliverable-meta > span,
  .deliverable-footer {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .deliverable-footer {
    min-height: 24px;
    justify-content: flex-end;
    color: var(--portal-muted);
  }

  .deliverable-footer .portal-status-pill {
    margin-right: auto;
  }

  @media (prefers-reduced-motion: reduce) {
    .deliverable {
      transition: none;
    }
  }
</style>
